import Settings from "@material-symbols/svg-500/rounded/settings.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const SettingsIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Settings });
	return <Icon />;
};

export default memo(SettingsIcon);
